import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SupportedLocale } from './getFlattenedLocales'
import type { SupportedAlpha3CountryCode } from './getSupportedAlpha3CountryCodes'

import { isSupportedLocale } from './isSupportedLocale'
import { toAlpha2 } from './toAlpha2'

type Props = {
  query: {
    [key: string]: string | string[] | undefined
  }
}

const defaultLocale: { locale: SupportedLocale } = { locale: 'en-US' }

export const getLocaleFromUrlQuery = ({
  query,
}: Props): {
  locale: SupportedLocale
  alpha2: Alpha2CountryCode
} => {
  if (!query.alpha3 || !query.language) {
    return {
      locale: defaultLocale.locale,
      alpha2: 'US',
    }
  }

  const alpha2: Alpha2CountryCode = toAlpha2(
    query.alpha3 as SupportedAlpha3CountryCode,
  ) as Alpha2CountryCode

  const locale = `${query.language}-${alpha2}`

  if (!isSupportedLocale(locale)) {
    return {
      locale: defaultLocale.locale,
      alpha2: 'US',
    }
  }

  return { locale, alpha2 }
}
